(function () {
  function getCarouselParts(carousel) {
    return {
      track: carousel.querySelector('[data-dlx-carousel-track]'),
      previous: carousel.querySelector('[data-dlx-carousel-prev]'),
      next: carousel.querySelector('[data-dlx-carousel-next]'),
    };
  }

  function updateCarousel(carousel) {
    var parts = getCarouselParts(carousel);
    if (!parts.track || !parts.previous || !parts.next) return;

    var maxScroll = Math.max(0, parts.track.scrollWidth - parts.track.clientWidth);
    var canScroll = maxScroll > 2;

    carousel.classList.toggle('is-static', !canScroll);
    parts.previous.disabled = !canScroll || parts.track.scrollLeft <= 2;
    parts.next.disabled = !canScroll || parts.track.scrollLeft >= maxScroll - 2;
  }

  function moveCarousel(button, direction) {
    if (button.disabled) return;

    var carousel = button.closest('[data-dlx-product-carousel]');
    if (!carousel) return;

    var track = carousel.querySelector('[data-dlx-carousel-track]');
    if (!track) return;

    var card = track.querySelector('.dlx-product-card');
    var gap = 18;
    var step = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;

    track.scrollBy({ left: direction * step, behavior: 'smooth' });
    window.setTimeout(function () {
      updateCarousel(carousel);
    }, 260);
  }

  function initCarousel(carousel) {
    var parts = getCarouselParts(carousel);
    if (!parts.track) return;

    var scrollFrame;
    parts.track.addEventListener('scroll', function () {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(function () {
        updateCarousel(carousel);
      });
    });

    window.addEventListener('resize', function () {
      updateCarousel(carousel);
    });

    updateCarousel(carousel);
  }

  document.addEventListener('click', function (event) {
    var previous = event.target.closest('[data-dlx-carousel-prev]');
    if (previous) {
      moveCarousel(previous, -1);
      return;
    }

    var next = event.target.closest('[data-dlx-carousel-next]');
    if (next) moveCarousel(next, 1);
  });

  function initAllCarousels() {
    document.querySelectorAll('[data-dlx-product-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCarousels);
  } else {
    initAllCarousels();
  }
})();
